var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36849 23.416C5.82791 23.416 5.39029 22.8668 5.39029 22.1947C5.39029 21.9573 5.19866 21.7656 4.96125 21.7656C4.72387 21.7656 4.53222 21.9573 4.53222 22.1947C4.53222 22.8668 4.09462 23.416 3.55403 23.416C3.31663 23.416 3.125 23.6076 3.125 23.845C3.125 24.0824 3.31663 24.274 3.55403 24.274C4.09462 24.274 4.53222 24.8203 4.53222 25.4954C4.53222 25.7327 4.72387 25.9244 4.96125 25.9244C5.19866 25.9244 5.39029 25.7327 5.39029 25.4954C5.39029 24.8203 5.82791 24.274 6.36849 24.274C6.60588 24.274 6.79752 24.0824 6.79752 23.845C6.79752 23.6076 6.60588 23.416 6.36849 23.416Z",
    fill: "url(#paint0_linear_665_28125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0805 14.5031C25.0805 14.7411 24.8901 14.9315 24.6521 14.9315C18.8421 14.9315 14.1185 20.5119 14.1185 27.3747C14.1185 27.6127 13.9253 27.8031 13.6901 27.8031C13.4521 27.8031 13.2589 27.6127 13.2589 27.3747C13.2589 20.5119 8.53528 14.9315 2.72528 14.9315C2.48727 14.9315 2.29688 14.7411 2.29688 14.5031C2.29688 14.2651 2.48727 14.0747 2.72528 14.0747C8.53528 14.0747 13.2589 8.49432 13.2589 1.63152C13.2589 1.39352 13.4521 1.20312 13.6901 1.20312C13.9253 1.20312 14.1185 1.39352 14.1185 1.63152C14.1185 8.49432 18.8421 14.0747 24.6521 14.0747C24.8901 14.0747 25.0805 14.2651 25.0805 14.5031Z",
    fill: "url(#paint1_linear_665_28125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7044 5.06143C25.7044 5.29942 25.514 5.48982 25.276 5.48982C24.2848 5.48982 23.4812 6.46982 23.4812 7.67383C23.4812 7.90903 23.288 8.10223 23.0528 8.10223C22.8148 8.10223 22.6244 7.90903 22.6244 7.67383C22.6244 6.46982 21.818 5.48982 20.8268 5.48982C20.5944 5.48982 20.3984 5.29942 20.3984 5.06143C20.3984 4.82622 20.5944 4.63302 20.8268 4.63302C21.818 4.63302 22.6244 3.65302 22.6244 2.45183C22.6244 2.21664 22.8148 2.02344 23.0528 2.02344C23.288 2.02344 23.4812 2.21664 23.4812 2.45183C23.4812 3.65302 24.2848 4.63302 25.276 4.63302C25.514 4.63302 25.7044 4.82622 25.7044 5.06143Z",
    fill: "url(#paint2_linear_665_28125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665_28125",
    x1: -8.73876,
    y1: 10.0954,
    x2: 17.3421,
    y2: 36.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D59A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_665_28125",
    x1: 13.6887,
    y1: 14.5031,
    x2: 28.5183,
    y2: 15.4787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B4A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884413,
    stopColor: "#5094E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_665_28125",
    x1: 9.73211,
    y1: -8.30549,
    x2: 35.813,
    y2: 17.8698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D59A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBlue);
export default __webpack_public_path__ + "static/media/start_blue.a163609002f44ea643efa58d12f600e0.svg";
export { ForwardRef as ReactComponent };